// Tiny inline toast for Lumi — no extra deps. Renders a top-center stack.
import { useEffect, useState } from "react";

let _push = () => {};
export const toast = {
  success: (msg) => _push({ type: "success", msg }),
  error: (msg) => _push({ type: "error", msg }),
  info: (msg) => _push({ type: "info", msg }),
};

export function LumiToaster() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    _push = ({ type, msg }) => {
      const id = Math.random().toString(36).slice(2);
      setItems((s) => [...s, { id, type, msg }]);
      setTimeout(() => setItems((s) => s.filter((i) => i.id !== id)), 4000);
    };
    return () => { _push = () => {}; };
  }, []);

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[1000] space-y-2 pointer-events-none">
      {items.map((i) => (
        <div
          key={i.id}
          className={`pointer-events-auto px-4 py-2 rounded-lg text-sm shadow-lg border ${
            i.type === "success" ? "bg-emerald-900/90 text-emerald-100 border-emerald-400/30" :
            i.type === "error"   ? "bg-red-900/90 text-red-100 border-red-400/30" :
                                    "bg-zinc-800/95 text-white border-white/20"
          }`}
        >
          {i.msg}
        </div>
      ))}
    </div>
  );
}
